import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter, Route, Routes } from 'react-router';
import { LoginPage, ProtectedRoute } from '@/features/auth';
import { AdminLayout } from '@/layouts/AdminLayout';
import { RecentScansPage } from '@/pages/RecentScansPage';
import { DashboardPage } from '@/pages/DashboardPage';
// TanStack Query client — configure global defaults here
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: 1,
        },
    },
});
export default function App() {
    return (_jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { element: _jsx(ProtectedRoute, {}), children: _jsxs(Route, { element: _jsx(AdminLayout, {}), children: [_jsx(Route, { path: "/", element: _jsx(RecentScansPage, {}) }), _jsx(Route, { path: "/diagnostics", element: _jsx(DashboardPage, {}) })] }) })] }) }), _jsx(ReactQueryDevtools, { initialIsOpen: false })] }));
}
